export function temPermissao(
  permissoes: Record<string, Record<string, string>> | null | undefined,
  modulo: string,
  acao: string
): boolean {
  if (!permissoes || typeof permissoes !== 'object') {
    return false;
  }
  return permissoes?.[modulo]?.[acao] === "sim";
}

/** Chaves do módulo Preventivas — usadas para não sumirem ao editar usuário */
export const PERMISSOES_PREVENTIVAS = {
  acessar_modulo: "nao",
  gerenciar_tipos: "nao",
  gerenciar_ativos: "nao",
  gerenciar_planos: "nao",
  gerar_os: "nao",
} as const;

/** Garante que o JSON tenha o bloco preventivas (sem sobrescrever valores já existentes). */
export function garantirModuloPreventivas(
  permissoes: Record<string, Record<string, string>> | null | undefined
): Record<string, Record<string, string>> {
  const base = permissoes && typeof permissoes === "object" ? { ...permissoes } : {};
  base.preventivas = {
    ...PERMISSOES_PREVENTIVAS,
    ...(base.preventivas || {}),
  };
  return base;
}
